import { useState, useContext } from "react";
import { ShopContext } from "../Context/ShopContext";
import FilterButton from "../SmallComponents/FilterButton";
import GridSection from "./GridSection";
import Pagination from "./Pagination";
import SearchBar from "./SearchBar";
import LoadingSpinner from "../SmallComponents/LoadingSpinner";

const CollectionsPage = () => {
  const { products } = useContext(ShopContext);
  const [activeFilters, setActiveFilters] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const itemsPerPage = 12;

  const handleFilterClick = (category) => {
    setIsLoading(true);
    setActiveFilters((prev) => {
      if (category === "all") {
        return [];
      }
      const newFilters = prev.includes(category)
        ? prev.filter((item) => item !== category)
        : [...prev, category];
      return newFilters;
    });
    setCurrentPage(1);

    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  const filteredProducts = products.filter(
    (product) =>
      activeFilters.length === 0 || activeFilters.includes(product.category)
  );

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentProducts = filteredProducts.slice(startIndex, endIndex);

  return (
    <div className="bg-transparent w-full p-4 pb-28">
      <div className="bg-transparent">
        {/* Title */}
        <p className="black-text montserrat tracking-tight text-center lg:text-xl lg:-mb-4 pt-10">
          Shop the latest design trends now.
        </p>
        <h2 className="playfair-display heading-1 mb-4 text-prime-red">
          Our new collection 2025
        </h2>

        <SearchBar />

        {/* Filters */}
        <div className="filters mt-4 lg:px-10 col lg:flex-row gap-4  lg:gap-20  lg:justify-between md:py-4 ">
          <h3 className="text-xl md:text-2xl black-text font-semibold lg:text-3xl">
            Filters
          </h3>

          {/* Buttons */}
          <div className="grid grid-cols-3 gap-2 md:w-[600px] md:grid-cols-4 lg:-ml-20 z-[999] ">
            <button
              className={`px-4 py-2 rounded-sm border border-prime-red cursor-pointer transition-all duration-300 ${
                activeFilters.length === 0
                  ? "bg-prime-red text-zinc-100"
                  : "bg-transparent text-prime-red hover:bg-prime-red/10"
              }`}
              onClick={() => handleFilterClick("all")}
            >
              All
            </button>
            <FilterButton
              title="Wedding"
              isActive={activeFilters.includes("Wedding")}
              onClick={() => handleFilterClick("Wedding")}
            />
            <FilterButton
              title="Corporate"
              isActive={activeFilters.includes("Corporate")}
              onClick={() => handleFilterClick("Corporate")}
            />
            <FilterButton
              title="Graduation"
              isActive={activeFilters.includes("Graduation")}
              onClick={() => handleFilterClick("Graduation")}
            />
          </div>
          <div></div>
        </div>

        {/* GRID */}
        {isLoading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-4 md:px-4 lg:px-4 mt-10 bg-transparent gap-4 lg:gap-5 lg:gap-y-20 py-8 md:py-16 lg:py-18 relative">
            {[...Array(8)].map((_, index) => (
              <LoadingSpinner key={index} />
            ))}
          </div>
        ) : (
          <GridSection products={currentProducts} />
        )}

        {/* Pagination */}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default CollectionsPage;
